import { avalanche as viemAvalanche } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const avalanche = {
  displayName: 'Avalanche',
  runtime: 'evm',
  viemChain: viemAvalanche,
  isSupported: true,
  isMainnet: true,
  isReleased: true,
  orderPriority: 9,
  decoration: {
    color: '#FF394A',
    contrastColor: getContrastColor('#FF394A'),
  },
  features: {
    wallet: { supported: true, import: false },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'avalanche-mainnet',
        urlSuffix: 'ext/bc/C/rpc',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://snowtrace.io',
        token: 'https://snowtrace.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '43114',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'AVA' },
    stargate: { chainKey: 'avalanche' },
    okx: { chainKey: '43114' },
    kyberswap: { chainKey: 'avalanche' },
    houdini: { chainKey: 'AVAX' },
  }),
  services: defaultServices({
    codex: {
      networkId: 43114,
      nativeLiquidityAddress: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
    },
    coingecko: {
      networkId: 'avalanche',
      platformId: 'avalanche',
    },
    coingeckoDex: {
      networkId: 'avax',
    },
    defiLlama: { chainKeys: ['avalanche'] },
    trm: { chainKey: 'avalanche_c_chain' },
    zerion: { chainKey: 'avalanche' },
    qnStreams: {
      networkKey: 'avalanche-mainnet',
    },
    safe: { shortName: 'avax' },
    pimlico: { chainSlug: 'avalanche' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
